import { Form } from 'antd';
import './index.less'
import { useEffect, useState } from 'react';
import { AmountType } from '../../type';
import { divBN, dividedBy, formatDecimalWithZeros, formatNumber, getRandomAmount, minus, multip, sum, sumAmounts } from '@/utils';
import { calculateTotalBalances } from '../ImportWalletKey/wallet';
import { useTranslation } from 'react-i18next';
import { formatEther, formatUnits } from 'ethers';
import { getChainsResource } from '@/utils/methods';
import { cdnUrl } from '@/utils/cdn';
import BasicInfo from '@/pages/TokenManagement/components/BasicInfo';

const { imgPathPrefix } = getChainsResource();
export default function InfoCard({ token, wallets, form, gasPriceWei, basicInfo }: any) {
  const { t } = useTranslation()
  const values: any = Form.useWatch([], form);
  const [displayAmount, setDisplayAmount] = useState<any>(0)
  const [totalGas, setTotalGas] = useState<any>(0)
  // 钱包数量 * 推导的数量
  // 如果是选择余额 则钱包的余额累加

  function countAmount() {
    const { type, fixedAmount, randomAmountStart, randomAmountEnd, remainAmount, allAmount, amounts } = values
    let amount: any = 0
    const walletsNum = wallets.length

    if (type === AmountType.FixedAmount) {
      amount = multip(walletsNum, fixedAmount || 0)
    }

    if (type === AmountType.RandomRange) {
      // const randomAmount = getRandomAmount(randomAmountStart, randomAmountEnd)
      // amount = multip(walletsNum, randomAmount)
      // console.log("RandomRange wallets", wallets)
      amount = wallets.reduce((total: any, wallet: any) => total + Number(wallet.opAmount || 0), 0);
    }

    if (type === AmountType.AllBalance) {
      const { totalSelectedBalance, totalSelectedTokenBalance } = calculateTotalBalances(wallets)
      amount = token?.address?.startsWith('0x') ? totalSelectedTokenBalance : totalSelectedBalance
    }

    if (type === AmountType.KeepFixedAmount) {
      const { totalSelectedBalanceWei, totalSelectedTokenBalanceWei } = calculateTotalBalances(wallets)
      const totalKeepAmount = multip(remainAmount, walletsNum)
      const totalKeepAmountWei = multip(totalKeepAmount, Math.pow(10, token.decimals))
      const diffWei = minus(token?.address?.startsWith('0x') ? totalSelectedTokenBalanceWei : totalSelectedBalanceWei, totalKeepAmountWei)
      amount = dividedBy(diffWei, Math.pow(10, token.decimals))
    }

    if (type === AmountType.Custom) {
      console.log(amounts)
      amount = sumAmounts(amounts || '')
    }

    setDisplayAmount(amount)
  }

  function handleGas() {
    // const fee = sum(jitoFeeAmount, oneTransGasFee)
    // const totalGas = multip(wallets.length, formatUnits(gasPriceWei.toString(), "gwei"))
    const totalGas = formatEther(gasPriceWei * BigInt(wallets.length))
    setTotalGas(totalGas)
  }


  useEffect(() => {
    if (values && wallets) {
      countAmount()
    }
  }, [values, wallets])

  useEffect(() => {
    if (wallets) {
      handleGas()
    }
  }, [wallets])



  return (
    <div className="info-card-box">
      <div className="info-card-item">
        <div className="info-label">{t("manyToMany.currency")}</div>
        <div className='info-card-item-head'>
          <img src={basicInfo?.iconUrl || cdnUrl(`/img/chains/sui.svg`)} alt={basicInfo?.symbol} className="token-logo" />
          <strong>{basicInfo?.symbol}</strong>
        </div>
      </div>
      <div className="info-card-item">
        <div className="info-label">{t("manyToMany.numberOfAddresses")}</div>
        <div className='info-card-item-head'>
          <strong>{wallets?.length || 0}</strong>
        </div>
      </div>
      <div className="info-card-item">
        <div className="info-label">{t("manyToMany.transferAmount")}</div>
        <div className='info-card-item-head'>
          <strong>{formatNumber(displayAmount, 4)} {basicInfo?.symbol}</strong>
        </div>
      </div>
      <div className="info-card-item">
        <div className="info-label">{t("manyToMany.estimatedGas")}</div>
        <div className='info-card-item-head'>
          <strong>{wallets.length * 0.002} {"SUI"}</strong>
        </div>
      </div>
    </div>
  );
}